<script lang="ts">
  import { browser } from '$app/environment';
  // Import all stores

  import { additionalInfoCacheStore } from '$src/stores/additional-info-cache.store';
  import { authStatus, isLoggedIn } from '$src/stores/auth.store';
  import {
    fetchedCategories,
    fetchedSubcategories,
    fetchedCategoryStrings
  } from '$src/stores/categories.store';
  //  TODO: fetch the functions and hook to buttons
  import {
    challengePostsStore,
    challengeStore,
    challengesLoading
  } from '$src/stores/challenges.store';

  import {
    firebaseStore,
    firebaseAuthStore,
    firebaseMessaging,
    firebaseMessagingToken
  } from '$src/stores/firebase.store';

  import { isMobile, isTablet } from '$src/stores/media.store';
  import {
    chatAreaHeightBeforeLazyLoad,
    directMessageToUser,
    fileUploadProgress,
    hasUnreadChats,
    isMessagesInputSelected,
    isMessagesMenuOpen,
    isUserSectionOpen,
    messageRooms,
    messages,
    messagesValue,
    replyTo,
    savedInputMessages,
    selectedRoom
  } from '$src/stores/messages.store';

  import {
    PostBoxSelected,
    createSelectedTab,
    homeSelectedTab,
    isDraft,
    isHomeMenuOpen,
    isProfileMenuOpen,
    myProfileSelectedTab,
    noNav,
    otherProfileSelectedTab,
    selectedPrimaryNavItem
  } from '$src/stores/nav.store';

  import { notificationsStore, notificationsUnreadStore } from '$src/stores/notifications.store';

  import {
    isOwner,
    itemData,
    selectedCategory,
    selectedSubCategory
  } from '$src/stores/posts.store';

  import {
    onBlockedListener,
    onDeleteListener,
    onEditListener,
    onMessageListener,
    onReadListener,
    onlineListener,
    socketIOStore,
    typingListener
  } from '$src/stores/socketio.store';

  import { me, userData, userUpdate, profileSelectedTab } from '$src/stores/user.store';
  import { scale } from 'svelte/transition';

  import StorePre from './_storeViewer/StorePre.svelte';
  import DebugButton from './DebugButton.svelte';
  import ThemeToggle from './ThemeToggle.svelte';

  // Attach a keypress listener to insert key being pressed that toggles a boolean
  // that will be used to show/hide the debug panel

  let debugPanel = false;
  let selectedStore: RadioSelect = 'user';

  type RadioSelect =
    | 'user'
    | 'firebase'
    | 'firebaseAuth'
    | 'firebaseMessaging'
    | 'additionalInfoCache'
    | 'auth'
    | 'categories'
    | 'challenges'
    | 'media'
    | 'messages'
    | 'nav'
    | 'notifications'
    | 'posts'
    | 'drafts'
    | 'socketio';

  let routeMap = {
    '/create-post': 'categories',
    '/messages': 'messages',
    '/notifications': 'notifications'
  };

  if (browser) {
    window.addEventListener('keydown', e => {
      if (e.key === 'Insert') {
        debugPanel = !debugPanel;
      }
    });
  }
</script>

{#key debugPanel}
  <div
    transition:scale={{ start: 0.9 }}
    class="
    p-8 pb-12 z-[99999] w-full font-lexend
    transition-colors duration-200
    border shadow-md
    border-stone-400 dark:border-dark-60
    bg-white dark:bg-dark-80
    text-stone-800 dark:text-dark-30
    top-10"
    class:absolute={debugPanel}
    class:hidden={!debugPanel}
  >
    <span>
      <h2 class="text-2xl font-light pb-2 text-stone-700 dark:text-dark-30">Stores</h2>
    </span>
    <div class="flex flex-row gap-2 font-light text-xs">
      <input type="radio" id="drafts" name="store" bind:group={selectedStore} value="drafts" />
      <label for="drafts">Drafts</label>

      <input type="radio" id="drafts" name="store" bind:group={selectedStore} value="user" />
      <label for="user">User</label>

      <input type="radio" id="firebase" name="store" bind:group={selectedStore} value="firebase" />
      <label for="firebase">Firebase</label>
      <input
        type="radio"
        id="additionalInfoCache"
        name="store"
        bind:group={selectedStore}
        value="additionalInfoCache"
      />
      <label for="additionalInfoCache">Additional Info Cache</label>
      <input type="radio" id="auth" name="store" bind:group={selectedStore} value="auth" />
      <label for="auth">Auth</label>
      <input
        type="radio"
        id="categories"
        name="store"
        bind:group={selectedStore}
        value="categories"
      />
      <label for="categories">Categories</label>
      <input
        type="radio"
        id="challenges"
        name="store"
        bind:group={selectedStore}
        value="challenges"
      />
      <label for="challenges">Challenges</label>
      <input type="radio" id="media" name="store" bind:group={selectedStore} value="media" />
      <label for="media">Media</label>
      <input type="radio" id="messages" name="store" bind:group={selectedStore} value="messages" />
      <label for="messages">Messages</label>
      <input type="radio" id="nav" name="store" bind:group={selectedStore} value="nav" />
      <label for="nav">Nav</label>
      <input
        type="radio"
        id="notifications"
        name="store"
        bind:group={selectedStore}
        value="notifications"
      />
      <label for="notifications">Notifications</label>
      <input type="radio" id="posts" name="store" bind:group={selectedStore} value="posts" />
      <label for="posts">Posts</label>
      <input type="radio" id="socketio" name="store" bind:group={selectedStore} value="socketio" />
      <label for="socketio">SocketIO</label>
    </div>

    {#if selectedStore === 'drafts'}
      <div class="py-4 px-2">
        <h3 class="text-lg font-light">Drafts</h3>
      </div>
    {/if}

    {#if selectedStore === 'additionalInfoCache'}
      <div class="py-4 px-2">
        <h3 class="text-lg font-light">additional-info-cache</h3>
        <div class="flex flex-col gap-1">
          <StorePre store={additionalInfoCacheStore} storeLabel="additionalInfoCacheStore" />
        </div>
      </div>
    {/if}

    {#if selectedStore === 'auth'}
      <div class="py-4 px-2">
        <h3 class="text-lg font-light">Auth store</h3>
        <div class="flex flex-col gap-1">
          <StorePre store={authStatus} storeLabel="authStatus" />
          <StorePre store={isLoggedIn} storeLabel="isLoggedIn" />
        </div>
      </div>
    {/if}

    {#if selectedStore === 'categories'}
      <div class="py-4 px-2">
        <h3 class="text-lg font-light">Categories store</h3>
        <div class="flex flex-col gap-1">
          <StorePre store={fetchedCategories} storeLabel="fetchedCategories" />
          <StorePre store={fetchedSubcategories} storeLabel="fetchedSubcategories" />
          <StorePre store={fetchedCategoryStrings} storeLabel="fetchedCategoryStrings" />
        </div>
      </div>
    {/if}

    {#if selectedStore === 'challenges'}
      <div class="py-4 px-2">
        <h3 class="text-lg font-light">Challenges store</h3>
        <div class="flex flex-col gap-1">
          <StorePre store={challengePostsStore} storeLabel="challengePostsStore" />
          <StorePre store={challengeStore} storeLabel="challengeStore" />
          <StorePre store={challengesLoading} storeLabel="challengesLoading" />
        </div>
      </div>
    {/if}

    {#if selectedStore === 'media'}
      <div class="py-4 px-2">
        <h3 class="text-lg font-light">Media store</h3>
        <div class="flex flex-col gap-1">
          <StorePre store={isMobile} storeLabel="isMobile" />
          <StorePre store={isTablet} storeLabel="isTablet" />
        </div>
      </div>
    {/if}

    {#if selectedStore === 'messages'}
      <div class="py-4 px-2">
        <h3 class="text-lg font-light">Messages store</h3>
        <div class="flex flex-col gap-1">
          <StorePre
            store={chatAreaHeightBeforeLazyLoad}
            storeLabel="chatAreaHeightBeforeLazyLoad"
          />
          <StorePre store={directMessageToUser} storeLabel="directMessageToUser" />
          <StorePre store={fileUploadProgress} storeLabel="fileUploadProgress" />
          <StorePre store={hasUnreadChats} storeLabel="hasUnreadChats" />
          <StorePre store={isMessagesInputSelected} storeLabel="isMessagesInputSelected" />
          <StorePre store={isMessagesMenuOpen} storeLabel="isMessagesMenuOpen" />
          <StorePre store={isUserSectionOpen} storeLabel="isUserSectionOpen" />
          <StorePre store={messageRooms} storeLabel="messageRooms" />
          <StorePre store={messages} storeLabel="messages" />
          <StorePre store={messagesValue} storeLabel="messagesValue" />
          <StorePre store={replyTo} storeLabel="replyTo" />
          <StorePre store={savedInputMessages} storeLabel="savedInputMessages" />
          <StorePre store={selectedRoom} storeLabel="selectedRoom" />
        </div>
      </div>
    {/if}

    {#if selectedStore === 'nav'}
      <div class="py-4 px-2">
        <h3 class="text-lg font-light">Nav store</h3>
        <div class="flex flex-col gap-1">
          <StorePre store={PostBoxSelected} storeLabel="PostBoxSelected" />
          <StorePre store={createSelectedTab} storeLabel="createSelectedTab" />
          <StorePre store={homeSelectedTab} storeLabel="homeSelectedTab" />
          <StorePre store={isDraft} storeLabel="isDraft" />
          <StorePre store={isHomeMenuOpen} storeLabel="isHomeMenuOpen" />
          <StorePre store={isProfileMenuOpen} storeLabel="isProfileMenuOpen" />
          <StorePre store={myProfileSelectedTab} storeLabel="myProfileSelectedTab" />
          <StorePre store={noNav} storeLabel="noNav" />
          <StorePre store={otherProfileSelectedTab} storeLabel="otherProfileSelectedTab" />
          <StorePre store={selectedPrimaryNavItem} storeLabel="selectedPrimaryNavItem" />
        </div>
      </div>
    {/if}

    {#if selectedStore === 'notifications'}
      <div class="py-4 px-2">
        <h3 class="text-lg font-light">Notifications store</h3>
        <div class="flex flex-col gap-1">
          <StorePre store={notificationsStore} storeLabel="notificationsStore" />
          <StorePre store={notificationsUnreadStore} storeLabel="notificationsUnreadStore" />
        </div>
      </div>
    {/if}

    {#if selectedStore === 'posts'}
      <div class="py-4 px-2">
        <h3 class="text-lg font-light">Posts store</h3>
        <div class="flex flex-col gap-1">
          <StorePre store={isOwner} storeLabel="isOwner" />
          <StorePre store={itemData} storeLabel="itemData" />
          <StorePre store={selectedCategory} storeLabel="selectedCategory" />
          <StorePre store={selectedSubCategory} storeLabel="selectedSubCategory" />
        </div>
      </div>
    {/if}

    {#if selectedStore === 'socketio'}
      <div class="py-4 px-2">
        <h3 class="text-lg font-light">SocketIO store</h3>
        <div class="flex flex-col gap-1">
          <StorePre store={onBlockedListener} storeLabel="onBlockedListener" />
          <StorePre store={onDeleteListener} storeLabel="onDeleteListener" />
          <StorePre store={onEditListener} storeLabel="onEditListener" />
          <StorePre store={onMessageListener} storeLabel="onMessageListener" />
          <StorePre store={onReadListener} storeLabel="onReadListener" />
          <StorePre store={onlineListener} storeLabel="onlineListener" />
          <StorePre store={socketIOStore} storeLabel="socketIOStore" />
          <StorePre store={typingListener} storeLabel="typingListener" />
        </div>
      </div>
    {/if}

    {#if selectedStore === 'user'}
      <div class="py-4 px-2">
        <h3 class="text-lg font-light">User store</h3>
        <div class="flex flex-col gap-1">
          <StorePre store={me} storeLabel="me" />
          <StorePre store={userData} storeLabel="userData" />
          <StorePre store={userUpdate} storeLabel="userUpdate" />
          <StorePre store={profileSelectedTab} storeLabel="profileSelectedTab" />
        </div>
      </div>
    {/if}

    {#if selectedStore === 'firebase'}
      <div class="py-4 px-2">
        <h3 class="text-lg font-light">Firebase store</h3>
        <div class="flex flex-col gap-1">
          <StorePre store={firebaseStore} storeLabel="firebaseStore" />
          <StorePre store={firebaseAuthStore} storeLabel="firebaseAuthStore" />
          <StorePre store={firebaseMessaging} storeLabel="firebaseMessaging" />
          <StorePre store={firebaseMessagingToken} storeLabel="firebaseMessagingToken" />
        </div>
      </div>
    {/if}
    <ThemeToggle />

    <small
      class="absolute bottom-4 font-light right-4 px-4 py-2 flex flex-row gap-4 justify-center items-center"
    >
      <span> Toggle this view by pressing the insert key </span>
      <DebugButton
        on:click={() => {
          debugPanel = false;
        }}
        text="Close"
      />
    </small>
  </div>
{/key}
